import { render } from "./kochLogoLong.vue?vue&type=template&id=7e26c76c&scoped=true"
const script = {}

import "./kochLogoLong.vue?vue&type=style&index=0&id=7e26c76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e26c76c"]])

export default __exports__